import {
  GET_SHIPPING_DATA,
  GET_SHIPPING_DATA_SUCCESS,
  GET_SHIPPING_DATA_FAIL,
  //BOX SIZES
  ADD_BOX_SIZE,
  ADD_BOX_SIZE_SUCCESS,
  ADD_BOX_SIZE_FAIL,
  UPDATE_BOX_SIZE,
  UPDATE_BOX_SIZE_SUCCESS,
  UPDATE_BOX_SIZE_FAIL,
  DELETE_BOX_SIZE,
  DELETE_BOX_SIZE_SUCCESS,
  DELETE_BOX_SIZE_FAIL,
  //FEDEX/EMS PRICES
  ADD_PRICE,
  ADD_PRICE_SUCCESS,
  ADD_PRICE_FAIL,
  UPDATE_PRICE,
  UPDATE_PRICE_SUCCESS,
  UPDATE_PRICE_FAIL,
  DELETE_PRICE,
  DELETE_PRICE_SUCCESS,
  DELETE_PRICE_FAIL,
  //TAX PRICES
  ADD_TAX_PRICE,
  ADD_TAX_PRICE_SUCCESS,
  ADD_TAX_PRICE_FAIL,
  UPDATE_TAX_PRICE,
  UPDATE_TAX_PRICE_SUCCESS,
  UPDATE_TAX_PRICE_FAIL,
  DELETE_TAX_PRICE,
  DELETE_TAX_PRICE_SUCCESS,
  DELETE_TAX_PRICE_FAIL,
  ADD_COUNTRIES,
  // MOSCOW SHIPPING
  GET_MOSCOW_DATA,
  GET_MOSCOW_DATA_SUCCESS,
  GET_MOSCOW_DATA_FAIL,
  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

// GET SHIPING DATA
export const getShippingData = () => ({
  type: GET_SHIPPING_DATA
});
export const getShippingDataSuccess = (data) => ({
  type: GET_SHIPPING_DATA_SUCCESS,
  payload: data
});
export const getShippingDataFail = (error) => ({
  type: GET_SHIPPING_DATA_FAIL,
  payload: error
});
// ADD/UPDATE/DELETE NEW BOX SIZE
export const addBoxSize = (data) => ({
  type: ADD_BOX_SIZE,
  payload: data
});
export const addBoxSizeSuccess = (data) => ({
  type: ADD_BOX_SIZE_SUCCESS,
  payload: data
});
export const addBoxSizeFail = (error) => ({
  type: ADD_BOX_SIZE_FAIL,
  payload: error
});
export const updateBoxSize = (data) => ({
  type: UPDATE_BOX_SIZE,
  payload: data
});
export const updateBoxSizeSuccess = (data) => ({
  type: UPDATE_BOX_SIZE_SUCCESS,
  payload: data
});
export const updateBoxSizeFail = (error) => ({
  type: UPDATE_BOX_SIZE_FAIL,
  payload: error
});
export const deleteBoxSize = (data) => ({
  type: DELETE_BOX_SIZE,
  payload: data
});
export const deleteBoxSizeSuccess = (data) => ({
  type: DELETE_BOX_SIZE_SUCCESS,
  payload: data
});
export const deleteBoxSizeFail = (error) => ({
  type: DELETE_BOX_SIZE_FAIL,
  payload: error
});
// ADD/UPDATE/DELETE PRICES
export const addPrice = (data) => ({
  type: ADD_PRICE,
  payload: data
});
export const addPriceSuccess = (data) => ({
  type: ADD_PRICE_SUCCESS,
  payload: data
});
export const addPriceFail = (error) => ({
  type: ADD_PRICE_FAIL,
  payload: error
});
export const updatePrice = (data) => ({
  type: UPDATE_PRICE,
  payload: data
});
export const updatePriceSuccess = (data) => ({
  type: UPDATE_PRICE_SUCCESS,
  payload: data
});
export const updatePriceFail = (error) => ({
  type: UPDATE_PRICE_FAIL,
  payload: error
});
export const deletePrice = (data) => ({
  type: DELETE_PRICE,
  payload: data
});
export const deletePriceSuccess = (data) => ({
  type: DELETE_PRICE_SUCCESS,
  payload: data
});
export const deletePriceFail = (error) => ({
  type: DELETE_PRICE_FAIL,
  payload: error
});

// ADD/UPDATE/DELETE TAX PRICES
export const addTaxPrice = (data) => ({
  type: ADD_TAX_PRICE,
  payload: data
});
export const addTaxPriceSuccess = (data) => ({
  type: ADD_TAX_PRICE_SUCCESS,
  payload: data
});
export const addTaxPriceFail = (error) => ({
  type: ADD_TAX_PRICE_FAIL,
  payload: error
});
export const updateTaxPrice = (data) => ({
  type: UPDATE_TAX_PRICE,
  payload: data
});
export const updateTaxPriceSuccess = (data) => ({
  type: UPDATE_TAX_PRICE_SUCCESS,
  payload: data
});
export const updateTaxPriceFail = (error) => ({
  type: UPDATE_TAX_PRICE_FAIL,
  payload: error
});
export const deleteTaxPrice = (data) => ({
  type: DELETE_TAX_PRICE,
  payload: data
});
export const deleteTaxPriceSuccess = (data) => ({
  type: DELETE_TAX_PRICE_SUCCESS,
  payload: data
});
export const deleteTaxPriceFail = (error) => ({
  type: DELETE_TAX_PRICE_FAIL,
  payload: error
});

export const addCountries = (countries) => ({
  type: ADD_COUNTRIES,
  payload: countries
});
// GET MOSCOW DATA
export const getMoscowData = () => ({
  type: GET_MOSCOW_DATA
});
export const getMoscowDataSuccess = (data) => ({
  type: GET_MOSCOW_DATA_SUCCESS,
  payload: data
});
export const getMoscowDataFail = (error) => ({
  type: GET_MOSCOW_DATA_FAIL,
  payload: error
});
export const showLoading = (status) => ({
  type: SHOW_LOADING,
  payload: status
});
export const hideLoading = (status) => ({
  type: HIDE_LOADING,
  payload: status
});
